import React from "react";
import { Skeleton } from "@mui/material";

export const SkeletonWrapper = ({ children, loading, ...rest }) => {
  return <div {...rest}>{loading ? <Skeleton /> : children}</div>;
};
